
import { defineComponent } from "vue";

export default defineComponent({
  name: "ContactItem",
  props: {
    contact: {
      type: Object,
    },
  },
});
